import { useNavigate } from "react-router-dom";

import { useWorkspaces } from "@/queries";
import {
  getInitialActiveWorkspaceId,
  persistActiveWorkspaceId,
  resolveActiveWorkspaceId,
} from "@/utils/activeWorkspace";

export const useWorkspaceNavigation = () => {
  const navigate = useNavigate();
  const workspacesQuery = useWorkspaces();

  const handleOrganizationSelect = (organizationId: number, onComplete?: () => void): void => {
    const workspaces = workspacesQuery.data?.workspaces ?? [];
    const workspaceId = resolveActiveWorkspaceId({
      workspaces,
      storedWorkspaceId: getInitialActiveWorkspaceId(),
      organizationId,
    });

    if (workspaceId) {
      persistActiveWorkspaceId(workspaceId);
      navigate(`/workspace/${workspaceId}/home`);
    } else {
      navigate(`/home`);
    }
    onComplete?.();
  };

  const handleWorkspaceSelect = (workspaceId: number, onComplete?: () => void): void => {
    persistActiveWorkspaceId(workspaceId);
    navigate(`/workspace/${workspaceId}/home`);
    onComplete?.();
  };

  const handleManageOrganizations = (onComplete?: () => void): void => {
    navigate("settings/organizations");
    onComplete?.();
  };

  const handleManageWorkspaces = (organizationId?: number, onComplete?: () => void): void => {
    if (organizationId) {
      navigate(`settings/organizations?editingOrganization=${organizationId}&tab=workspaces`);
    } else {
      navigate("settings/organizations");
    }
    onComplete?.();
  };

  return {
    handleOrganizationSelect,
    handleWorkspaceSelect,
    handleManageOrganizations,
    handleManageWorkspaces,
  };
};
